<template>
  <div class="portal-information">
    <div class="wrap">
      <div class="inner-layout">
        <div class="inner-main">
          <!-- 子类tab -->
          <div class="tab">
            <ul>
              <li
                v-for="tab in caseList"
                :key="tab.id"
                :class="{ active: tab.active }"
              >
                <a :href="'/information?type=' + tab.id" v-if="tab.id">{{
                  tab.name
                }}</a>
                <a href="/information" v-else>{{ tab.name }}</a>
              </li>
            </ul>
          </div>
          <!-- 筛选条件 -->
          <div class="filter">
            <!-- <div class="title">
              <span>所有分类</span>
              <em
                :class="{ active: isShowCategory }"
                @click="isShowCategory = !isShowCategory"
                >展开筛选</em
              >
            </div> -->
            <!-- <div class="category" v-if="isShowCategory">
              <span class="label">行业分类：</span>
              <div class="group">
                <el-checkbox-group
                  v-model="tradeCheckedList"
                  @change="handleCreateCategory"
                >
                  <el-checkbox
                    :label="trade.name"
                    v-for="trade in tradeList"
                    :key="trade.id"
                    :value="trade.id"
                  >
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="category" v-if="isShowCategory">
              <span class="label">服务类型：</span>
              <div class="group">
                <el-checkbox-group
                  v-model="serviceCheckedList"
                  @change="handleCreateCategory"
                >
                  <el-checkbox
                    :label="service.name"
                    v-for="service in serviceList"
                    :key="service.id"
                    :value="service.id"
                  >
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div> -->
            <div class="search">
              <span class="label">关键词：</span>
              <div>
                <el-input
                  placeholder="请输入关键词"
                  size="small"
                  v-model="params.title"
                />
                <el-button
                  size="small"
                  type="primary"
                  @click="qryInformationList(1)"
                  >搜索</el-button
                >
              </div>
            </div>
            <div class="category" v-if="checkedList.length || params.title">
              <span class="label">您已选择：</span>
              <div class="group">
                <el-tag
                  size="small"
                  closable
                  @close="params.title = ''"
                  v-if="params.title"
                  >{{ params.title }}</el-tag
                >
                <el-tag
                  size="small"
                  v-for="category in checkedList"
                  :key="category.name"
                  closable
                  :type="String(category.id)"
                  @close="handleDeleteCategoryChecked(category.name)"
                >
                  {{ category.name }}
                </el-tag>
                <el-tag size="small" @click="handleClear">清除</el-tag>
              </div>
            </div>
          </div>
          <!-- 资源列表 -->
          <div class="list">
            <ul>
              <li v-for="info in informationList" :key="info.id">
                <div :class="{ content: true, hasImg: info.imgUrl }">
                  <h2>
                    <a
                      target="_blank"
                      :href="
                        '/case/' +
                        info.alias +
                        '/detail-' +
                        info.id +
                        '.html?catalogCode=' +
                        info.catalogCode
                      "
                    >
                      {{ info.title }}
                    </a>
                    <i v-if="info.original">原创</i>
                    <!-- <i v-if="info.catalogCode === 'jswz'" class="vip">VIP</i> -->
                  </h2>
                  <p v-html="info.content"></p>
                  <label>
                    <span>
                      {{ info.publishTime }}
                    </span>
                    <em>
                      <span
                        v-for="tag in info.catalogName.split(',')"
                        :key="tag"
                        >{{ tag }}</span
                      >
                    </em>
                    <i v-if="info.catalogName.split(',').length > 5">...</i>
                    <span>阅读： {{ info.hits || 0 }}</span>
                  </label>
                </div>
                <div v-if="info.imgUrl" class="img">
                  <img :src="info.imgUrl" :alt="info.title" />
                </div>
              </li>
            </ul>
          </div>
          <div class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="pageParams.pageNum"
              :total="totalNum"
              :page-size="pageParams.pageRow"
              layout="prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
        <div :class="{ side: true, fixed: isFixed }">
          <TicketInset :userInfo="userInfo" :env="env" v-bind="$attrs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { host } from "src/config";
import { getUserInfo, qryCase, qryCategory } from "./../../request/portal";
import TicketInset from "./TicketInset.vue";

export default {
  name: "PortalInformation",
  props: {
    env: {
      type: String,
      default: "local",
    },
    /* 执行的系统，portal member */
    system: {
      type: String,
      default: "portal",
    },
  },
  components: {
    TicketInset,
  },
  data() {
    return {
      host: host(this.env),
      level1Path: process.env.level1Path,
      caseList: [], // 二级分类列表
      isShowCategory: false, // 是否显示行业和服务分类
      serviceList: [], // 服务分类数据列表
      serviceCheckedList: [], // 服务分类选中的列表
      tradeList: [], // 行业分类数据源
      tradeCheckedList: [], // 行业分类选中的列表
      checkedList: [], // 已选类目列表
      informationList: [], // 资源列表
      pageParams: {
        pageNum: 1,
        pageRow: 10,
      }, // 查询分页数据对象
      totalNum: 0, // 资源列表总条数
      sideList: [], // 侧边栏数据列表
      params: {
        cid: "", // 当前分类索引ID
        title: "", // 关键词
        cataId: "", // 选中的服务和行业id集合，字符串类型
      },
      userInfo: {},
      isFixed: false, // 固定定位
    };
  },
  methods: {
    // 动态生成已选类目
    handleCreateCategory() {
      this.checkedList = [];
      this.serviceList.forEach((v) => {
        if (this.serviceCheckedList.includes(v.name)) this.checkedList.push(v);
      });
      this.tradeList.forEach((v) => {
        if (this.tradeCheckedList.includes(v.name)) this.checkedList.push(v);
      });
      /* 生成查询入参 */
      let cataId = [];
      this.checkedList.forEach((v) => {
        cataId.push(v.id);
      });
      this.params.cataId = cataId.join(",");
      this.qryInformationList(1);
    },
    // 删除已选类目，取消类目的选中状态
    handleDeleteCategoryChecked(val) {
      this.serviceCheckedList.forEach((v, index) => {
        if (v === val) this.serviceCheckedList.splice(index, 1);
      });
      this.tradeCheckedList.forEach((v, index) => {
        if (v === val) this.tradeCheckedList.splice(index, 1);
      });
      this.handleCreateCategory();
    },
    // 删除已选项目，取消类目的选中状态，全部删除
    handleClear() {
      this.params.title = "";
      this.serviceCheckedList = [];
      this.tradeCheckedList = [];
      this.handleCreateCategory();
    },
    /*
      资源列表查询，以及分页动作查询
    */
    qryInformationList(pageNum) {
      this.pageParams.pageNum = pageNum ? pageNum : this.pageParams.pageNum;
      qryCase(
        Object.assign(this.pageParams, this.params),
        this.host.nodeUrl
      ).then((res) => {
        this.informationList = res.data.items;
        this.totalNum = res.data.totalNum;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.qryInformationList();
    },
    // 右侧快捷模块
    handleToggle(index) {
      this.sideList = this.sideList.map((v, vIndex) => {
        if (index === vIndex) v.isShow = !v.isShow;
        return v;
      });
    },
    // 滚动事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log("scrollTop", scrollTop);
      if (scrollTop >= 177) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
  mounted() {
    // 滚动监听
    window.addEventListener("scroll", this.handleScroll);
    /* 通过url参数获取当前2级分类的id */
    const { type } = this.$route.query;
    if (type) this.params.cid = type;
    getUserInfo({}, this.host.nodeUrl).then((res) => {
      if (res.resultCode === "0") this.userInfo = res.data;
    });
    this.qryInformationList();
    qryCategory({}, this.host.nodeUrl).then((res) => {
      this.serviceList = res.data.services;
      this.tradeList = res.data.trades;
      this.caseList = [
        { name: "全部", id: "", active: true },
        ...res.data.cases.filter((v) => v.isShow),
      ];
      /* 设置tab选中状态 */
      if (type) {
        this.caseList.forEach((v) => {
          v.active = false;
          if (v.id == type) v.active = true;
        });
      }
      this.sideList = [
        {
          name: "行业解决方案",
          type: 1,
          items: this.tradeList,
        },
        {
          name: "我们的服务",
          type: 2,
          items: this.serviceList,
        },
        {
          name: "热点服务",
          type: 3,
          items: res.data.hotService,
        },
      ];
      // 初始化全部隐藏
      this.sideList = this.sideList.map((v) => {
        return Object.assign(v, { isShow: false });
      });
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.portal-information {
  background: #fff;
  padding-bottom: 100px;

  .inner-layout {
    padding-top: 33px;
    display: flex;
    justify-content: space-between;

    .inner-main {
      width: 850px;

      .tab {
        width: 850px;
        height: 62px;
        line-height: 62px;
        background: $innerBackgroupColor;

        ul {
          display: flex;
          flex-wrap: wrap;
          margin-left: 40px;

          li {
            position: relative;
            padding: 0 25px;
            cursor: pointer;

            a {
              color: #000;
            }

            &:hover::after {
              transform: scaleX(1);
            }

            &:hover {
              color: $mainColor;
            }

            &::after {
              position: absolute;
              content: "";
              top: 59px;
              left: 0;
              width: 100%;
              height: 3px;
              background: $mainColor;
              transform: scaleX(0);
              transition: 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            }

            &.active::after {
              transform: scaleX(1);
            }

            i {
              display: none;
              width: 0;
              height: 0;
              position: absolute;
              overflow: hidden;
              font-size: 0;
              line-height: 0;
              border-width: 10px;
              border-style: solid dashed dashed dashed;
              border-color: transparent transparent $innerBackgroupColor
                transparent;
              top: 60px;
              left: 50%;
              transform: translateX(-50%);
            }

            &.active {
              i {
                display: block;
              }
            }
          }
        }
      }

      .filter {
        width: 100%;
        background: $innerBackgroupColor;
        margin-top: 18px;
        padding: 0 20px 20px 20px;
        float: left;

        .label {
          color: #878787;
          font-size: 14px;
          width: 90px;
          text-align-last: justify;
          text-align: justify;
          padding-left: 20px;
        }

        .title {
          border-bottom: 1px dashed #b5b5b5;
          float: left;
          width: 100%;
          padding: 13px 0;

          span,
          em {
            display: inline-block;
            color: #878787;
            font-size: 14px;
            height: 14px;
            line-height: 14px;
          }

          span {
            float: left;
            margin-left: 15px;
            background: url("./../../assets/images/information/download/right.png")
              no-repeat 60px 2px;
            padding-right: 15px;
          }

          em {
            float: right;
            margin-right: 15px;
            background: url("./../../assets/images/information/download/bottom.png")
              no-repeat 60px 4px;
            padding-right: 15px;
            cursor: pointer;

            &.active {
              color: $mainColor;
              background: url("./../../assets/images/information/download/top.png")
                no-repeat 60px 4px;
            }
          }
        }

        .group {
          width: 695px;
          display: flex;
          flex-wrap: wrap;
          margin-left: 10px;
          padding-right: 15px;

          .el-checkbox__label {
            font-size: 14px;
          }
        }

        .category {
          display: flex;
          border-bottom: 1px #d2d2d2 dashed;
          padding: 20px 0 5px 0;
          clear: both;
        }

        .search {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          padding: 20px 0 15px 0;

          div {
            display: flex;
            align-items: center;
            width: 322px;

            .el-input {
              margin: 0 0 0 15px !important;
            }
          }
        }
      }

      .list {
        margin: 10px 0 50px 0;
        width: 100%;
        display: flex;

        * {
          padding: 0;
          margin: 0;
        }

        li {
          border-bottom: 1px solid #ececec;
          height: 149px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:hover {
            h2 {
              a {
                color: $mainColor;
              }
            }

            p {
              color: #333;
            }
          }
        }

        .content {
          height: 95px;
          display: flex;
          flex-direction: column;
          flex: 1;

          &.hasImg {
            h2 {
              a {
                max-width: 539px;
              }
            }

            label {
              em {
                max-width: 486px;
              }
            }
          }

          h2 {
            display: flex;
            align-items: center;
            padding-bottom: 10px;

            a {
              color: #333;
              font-size: 18px;
              font-weight: normal;
              max-width: 754px;
              display: inline-block;
              height: 22px;
              line-height: 22px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            i {
              font-size: 12px;
              height: 18px;
              line-height: 18px;
              font-weight: normal;
              margin-left: 10px;
              max-width: 74px;
              padding: 0 5px;
              text-align: center;
              background: #eee;
              color: #959595;
              border-radius: 3px;

              &.vip {
                width: 31px;
                text-align: center;
                height: 18px;
                line-height: 18px;
                background: #ffeac9;
                border-radius: 3px;
                color: #8e6c32;
                font-size: 11px;
                font-family: Arial;
              }
            }
          }

          p {
            color: #959595;
            font-size: 12px;
            line-height: 20px;
            height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          label {
            padding-top: 10px;
            height: 12px;
            line-height: 12px;
            font-weight: normal;

            span {
              color: #959595;
              font-size: 12px;
              padding-right: 18px;
              display: block;
              height: 12px;
              line-height: 12px;
              float: left;
              border-left: 1px solid #c2c2c2;
              padding-left: 18px;

              &:first-child {
                padding-left: 0;
                border-left: 0;
              }

              // &:last-child {
              //   padding-right: 0;
              // }
            }

            em {
              display: block;
              max-width: 652px;
              height: 12px;
              overflow: hidden;
              line-height: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              float: left;

              span {
                &:first-child {
                  padding-left: 18px;
                  border-left: 1px solid #c2c2c2;
                }
              }
            }

            i {
              display: block;
              width: 10px;
              height: 16px;
              line-height: 16px;
              float: left;
              color: #c2c2cc;
            }
          }
        }

        .img {
          width: 150px;
          height: 95px;
          margin-left: 20px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            max-width: 150px;
            max-height: 95px;
          }
        }

        h3 {
          text-align: center;
          font-weight: normal;
          height: 100px;
          line-height: 100px;
        }
      }
    }

    // .inner-side {
    //   dl {
    //     background: $innerBackgroupColor;
    //     padding: 0 21px;

    //     // li {
    //     //   padding-bottom: 20px;
    //     // }

    //     dt {
    //       height: 74px;
    //       border-bottom: 1px solid #ccc;
    //       display: flex;
    //       justify-content: space-between;
    //       align-items: center;
    //       cursor: pointer;

    //       &.active {
    //         i {
    //           background: url('./../../assets/images/information/hide.png');
    //         }
    //       }

    //       i {
    //         display: block;
    //         width: 25px;
    //         height: 24px;
    //         background: url('./../../assets/images/information/show.png');
    //       }

    //     }

    //     dd {
    //       margin-top: 20px;
    //       font-size: 14px;

    //       a {
    //         color: #999;

    //         &:hover {
    //           color: $mainColor;
    //         }
    //       }
    //     }
    //   }
    // }

    .side {
      width: 360px;

      &.fixed {
        position: fixed;
        top: 0;
        right: calc(50% - 613px);
      }
    }
  }

  .el-checkbox {
    // width: 147px;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>
